document.addEventListener('DOMContentLoaded', () => {

  setTimeout(() => {    
    jQuery(".model-vehicle-colorizer").not('.slick-initialized').slick({
     "dots": false,
     "fade": true,
    "prevArrow": '<button class="slick-prev-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "nextArrow": '<button class="slick-next-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
     "infinite": true,
     "speed": 500,
     "slidesToShow": 1,
     "slidesToScroll": 1,
     "initialSlide": 0
   });
  }, 500);

  // GET THE INDEX OF THE SLIDE BEFORE THE CHANGE
  jQuery('.model-vehicle-colorizer').on('beforeChange', function(e, s, currentSlideIndex, nextSlide) {
    jQuery(`div[id!='${s.$slider[0].id}'].model-vehicle-colorizer`).slick('unslick');
    jQuery(`div[id!='${s.$slider[0].id}'].model-vehicle-colorizer`).slick({
      "dots": false,
      "fade": true,
    "prevArrow": '<button class="slick-prev-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "nextArrow": '<button class="slick-next-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
      "infinite": true,
      "speed": 500,
      "slidesToShow": 1,
      "slidesToScroll": 1,
      "initialSlide": nextSlide
    });
});

  const btnColor = document.querySelectorAll('.div-colors .btn-color.cursor-pointer');
  btnColor.forEach(btn => {
    btn.addEventListener('click', () => {
      let selectedFilter = btn.getAttribute('data-filter');
      let colorName = btn.getAttribute('data-colorName');
      
      selectedFilter = selectedFilter.split('|')[1];
      jQuery('.color-name').html(colorName);
      let hexColor = btn.getAttribute('data-filter').split('|')[2];
      jQuery("#stop-color-colorizer").attr("stop-color",hexColor);

      let itemsToHide = document.querySelectorAll(`.colorizer-section .colorizer-image-container:not([data-filter='${selectedFilter}'])`);
      let itemsToShow = document.querySelectorAll(`.colorizer-section [data-filter='${selectedFilter}']`);
      /* document.querySelector('.color-name').innerHTML = colorName; */

      jQuery(`.round-color`).removeClass("active");
      jQuery(`[data-filter='round|${selectedFilter}']`).addClass("active");
      
      // Adding Checkmarks
      jQuery(`.colorizer-checkmark`).removeClass("check-active");
      jQuery(`[data-filter='checkmark|${selectedFilter}']`).addClass("check-active animated");

      itemsToHide.forEach(el => {
        el.classList.add('hidden');
        el.classList.remove('block');
      });
      
      itemsToShow.forEach(el => {
        el.classList.remove('hidden');
        el.classList.add('block');
        //el.style.background = `linear-gradient(45deg, ${hexColor} 0, white 100%)`;
      });
      
      jQuery('.model-vehicle-colorizer').slick('refresh');
    })
  })

  window.addEventListener('resize', function() {
    jQuery('.model-vehicle-colorizer').slick('refresh');
  });

  /* 
  const btnReserve = document.querySelectorAll('.cta-reservenow');
  btnReserve.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      let leadInfo='&extradata=';

      let condition = document.querySelectorAll('.value__condition');  
      condition.forEach(lbl => {
        leadInfo+='Condition: ' + lbl.innerText + ' ';
      });

      const btnColors = document.querySelectorAll('.round-color.active');
      let color = jQuery(btnColors[0]).parent('span');
      color = color[0];
      leadInfo+='- Color: ' + color.getAttribute('data-colorname') + ' ';

      const leadFrequency = document.querySelectorAll('.leadFrequency'); 
      let frequency = "";
      leadFrequency.forEach(freq=>{
        if(freq.classList.contains('weekly')) frequency = 'Weekly';
        if(freq.classList.contains('bi-weekly')) frequency = 'Bi-Weekly';
        if(freq.classList.contains('monthly')) frequency = 'Monthly';
      })

      if (frequency != '')
        leadInfo+='- Frequency: ' + frequency + ' ';

      const leadData = document.querySelectorAll('.infoLead');
      leadData.forEach(inpt => {
        leadInfo += `- ${inpt.getAttribute('data-key')}: ` + `${inpt.value}` + ' ';
      })

      const leadLabels = document.querySelectorAll('.labelLead');
      leadLabels.forEach(lbl => {
        leadInfo+=`- ${lbl.getAttribute('data-key')}: ` + `${lbl.innerText}` + ' ';
      })

      const leadCheck = document.querySelectorAll('.checkLead');
      leadCheck.forEach(chk=>{
        leadInfo+=`- ${chk.getAttribute('data-key')}: ` + ((chk.checked)?'true':'false') + ' ';
      })

      const hrefValue = e.target.getAttribute('href')+leadInfo;

      window.location.href = hrefValue;
    })
  });
  */
});